<template>
  <b-row class="animated fadeIn">
    <b-col sm="12">
      <form v-on:submit.prevent="submit">
        <b-card>
          <div slot="header">
            <strong>Form</strong>
            <small v-if="$route.name === 'Tambah Data Cabang'">Tambah Cabang</small>
            <small v-if="$route.name === 'Edit Data Cabang'">Edit Cabang</small>
          </div>
          <b-row v-if="isLoading">
            <b-col sm="12">
              Loading
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col sm="12">
              <div class="alert alert-danger" v-if="errors.all().length != 0">
                <strong>Perhatian</strong>
                <ul>
                  <li v-for="error in errors.all()">{{ error }}</li>
                </ul>
              </div>
            </b-col>
            <b-col sm="12">
              <b-form-fieldset label="Nama Cabang" :label-cols="2" :horizontal="true">
                <input name="nama_cabang" class="form-control" data-vv-as="Nama Cabang" v-bind:class="{ 'is-invalid': errors.has('nama_cabang') }" v-validate="'required'" type="text" id="nama_cabang" placeholder="Masukan nama cabang" v-model="cabang.nama_cabang" />
              </b-form-fieldset>
            </b-col>
            <b-col sm="12">
              <b-form-fieldset label="Alamat" :label-cols="2" :horizontal="true">
                <input name="alamat" class="form-control" data-vv-as="Alamat" v-bind:class="{ 'is-invalid': errors.has('alamat') }" v-validate="'required'" type="text" id="name" placeholder="Masukan alamat" v-model="cabang.alamat" />
              </b-form-fieldset>
            </b-col>
            <b-col sm="12">
              <b-form-fieldset label="No Telp" :label-cols="2" :horizontal="true">
                <input name="no_telp" class="form-control" data-vv-as="No Telp" v-bind:class="{ 'is-invalid': errors.has('no_telp') }" v-validate="'required'" type="text" id="name" placeholder="Masukan no telp" v-model="cabang.no_telp" />
              </b-form-fieldset>
            </b-col>
          </b-row>

          <div slot="footer">
            <b-button type="submit" :block="true" variant="success"><i class="fa fa-save"></i> Simpan</b-button>
          </div>
        </b-card>
      </form>
    </b-col>
  </b-row>
</template>

<script>
  import Cabang from '@/model/Cabang'

  export default {
    data: () => {
      return {
        isLoading: false,
        usia: 0,
        id_cabang: '',
        cabang: {
          nama_cabang: '',
          alamat: '',
          no_telp: ''
        },
        config: {
          dateFormat: 'd-m-Y'
        }
      }
    },
    methods: {
      async store () {
        try {
          const cabang = await Cabang.addCabang(this.cabang)
          if (cabang.data.status) {
            this.$router.replace('/master/cabang')
            this.$toastr.s('Tambah data cabang berhasil')
          }
        } catch (e) {
          this.$toastr.e('Terjadi kesalahan pada server. Silahkan refresh halaman')
        }
      },
      async update () {
        try {
          const cabang = await Cabang.updateCabang(this.id_cabang, this.cabang)

          if (cabang.data.status) {
            this.$router.replace('/master/cabang')
            this.$toastr.s('Edit data cabang berhasil')
          }
        } catch (e) {
          this.$toastr.e('Terjadi kesalahan pada server. Silahkan refresh halaman')
        }
      },
      async getDetail () {
        var cabang = await Cabang.getCabangDetail(this.id_cabang)
        this.cabang = cabang.data.result
        this.isLoading = false
      },
      submit () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (typeof this.id_cabang !== 'undefined') this.update()
            else this.store()
          }
        })
      }
    },
    mounted () {
      this.id_cabang = this.$route.params.id
      if (typeof this.id_cabang !== 'undefined') {
        this.getDetail()
      }
    }
  }
</script>
